module.exports = __webpack_public_path__ + "img/history.fc3f4b49.jpg";